/* eslint-disable */
import { REDUX_ACTIONS } from '../global/constants';

function downloadsReducer(
    state = {
        downloads: [],
        attendedDownloads: [],
        downloadModels: [],
        activeScrollAnkerId: ''
    },
    action
) {
    switch (action.type) {
        case REDUX_ACTIONS.UPDATE_DOWNLOADS:
            return Object.assign({}, state, {
                downloads: action.downloads,
                downloadModels: action.downloadModels
            });

        case REDUX_ACTIONS.UPDATE_SCROLL_ANKER_EVENT_ID:
            return Object.assign({}, state, {
                activeScrollAnkerId: action.eventId
            });

        case REDUX_ACTIONS.UPDATE_ATTENDED_DOWNLOADS:
            return {
                ...state,
                attendedDownloads: action.attendedDownloads,
            };

        default:
            return state;
    }
}

export default downloadsReducer;
